export const team = {
    init: () => {
        const $ = jQuery;

        const modalTriggers = $('.team-item .more-icon');

        const modals = $('.team-overlay .modal');

        modalTriggers.on('click', (e) => {
            e.preventDefault();

            const member = $(e.currentTarget).data('member');

            modals.each((i, modal) => {
                const modalMember = $(modal).data('member');

                if (modalMember === member) {
                    $(modal).show();
                    $(modal).parent('.team-overlay').addClass('active');
                } else {
                    $(modal).hide();
                }
            });

            $('body').addClass('show-overlay');
        });
    }
}